import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { ReservationContactDto } from '../../../shared/modules/contacts/dtos/reservation-contact.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { ComputedPeriodDurationDto } from '../../../shared/modules/shared/dtos/computed-period-duration.dto';
import { ProtoDriverDto } from '../../drivers/dtos/proto-driver.dto';
import { AssetReservationStatusEnum } from '../enums/asset-reservation-status.enum';

import { AssetReservationLinksDto } from './asset-reservation-links.dto';

/**
 * Asset reservation record DTO
 */
@CaslSubject(AppSubjectEnum.ASSET_RESERVATION)
export class AssetReservationRecordDto extends BaseProtoDto {
  code!: string;
  qrCode?: string;
  status!: AssetReservationStatusEnum;
  notes?: string;
  startsAt!: Date;
  endsAt!: Date;
  accountId!: number;
  tenantOrgId?: string;
  assetUuid!: string;
  agentUuid?: string;
  pickupLocationUuid?: string;
  dropOffLocationUuid?: string;
  drivers?: ProtoDriverDto[];
  pricingItems?: PricingItemDto[];
  links?: AssetReservationLinksDto;
  reservationContact?: ReservationContactDto;
  files?: FileDto[];

  computedPeriod?: ComputedPeriodDurationDto;
  @TransformFloat() computedTotalNet?: number;
  @TransformFloat() computedTotalTax?: number;
  @TransformFloat() computedTotalGross?: number;
  @TransformFloat() computedDiscountNet?: number;
  @TransformFloat() computedDiscountTax?: number;
  @TransformFloat() computedDiscountGross?: number;
  @TransformFloat() computedStandardNet?: number;
  @TransformFloat() computedStandardTax?: number;
  @TransformFloat() computedStandardGross?: number;
  @TransformFloat() computedExtrasNet?: number;
  @TransformFloat() computedExtrasTax?: number;
  @TransformFloat() computedExtrasGross?: number;
  @TransformFloat() computedSavingsAmount?: number;
  @TransformFloat() computedSavingsPercentage?: number;
  @TransformFloat() computedOriginalStandardAmount?: number;
  @TransformFloat() computedCommissionNet?: number;
}
